import BaseValidator from './BaseValidator';

const UserValidator = {
  nameValidator(nameProps) {
    return BaseValidator.cannotEmpty(nameProps);
  },

  emailValidator(emailProps) {
    return BaseValidator.cannotEmpty(emailProps).then((response) => {
      if (!response.success) {
        return Promise.resolve(response);
      }
      return this.emailFormatValidator(response).then((result) =>
        Promise.resolve(result),
      );
    });
  },

  passwordValidator(passwordProps) {
    return BaseValidator.cannotEmpty(passwordProps).then((response) => {
      if (!response.success) {
        return Promise.resolve(response);
      }
      return this.passwordLengthValidator(response).then((result) =>
        Promise.resolve(result),
      );
    });
  },

  nicknameValidator(nicknameProps) {
    return Promise.resolve({
      success: true,
      props: nicknameProps,
      message: '',
    });
  },

  skypeIdValidator(skypeIdProps) {
    return BaseValidator.cannotEmpty(skypeIdProps);
  },

  teamsContactEmailValidator(teamsEmailProps) {
    return BaseValidator.cannotEmpty(teamsEmailProps).then((response) => {
      if (!response.success) {
        return Promise.resolve(response);
      }
      return this.emailFormatValidator(response).then((result) =>
        Promise.resolve(result),
      );
    });
  },

  localeValidator(localeProps) {
    return BaseValidator.cannotEmpty(localeProps);
  },

  timezoneValidator(timezoneProps) {
    return BaseValidator.cannotEmpty(timezoneProps);
  },

  bioValidator(bioProps) {
    return Promise.resolve({ success: true, props: bioProps, message: '' });
  },

  passwordLengthValidator(response) {
    return new Promise((resolve) => {
      let res;
      const t = response.props.t;
      if (response.props.value.length < 6) {
        res = {
          success: false,
          props: response.props,
          message: `${t('validators.PasswordtooShort')} `,
        };
      } else {
        res = {
          success: true,
          props: response.props,
          message: '',
        };
      }
      resolve(res);
    });
  },

  emailFormatValidator(response) {
    return new Promise((resolve) => {
      let res;
      const re = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
      const t = response.props.t;
      if (re.test(response.props.value) === false) {
        res = {
          success: false,
          props: response.props,
          message: `${t('validators.emailFormatInvalid')} `,
        };
      } else {
        res = { success: true, props: response.props, message: '' };
      }
      resolve(res);
    });
  },
};

export default UserValidator;
